import {
  RegisterAndSubscribeToMachineBindingDocument,
  RegisterAndSubscribeToMachineBindingSubscriptionResult,
  RegisterAndSubscribeToMachineBindingSubscriptionVariables,
} from '../../graphql/generated';
import { useApolloSharedSubscription } from '../../subscription/apollo-subscription.manager';

export type RegisterBindingCallback = (
  result: MachineRegisterBindingResult
) => void;

export interface RegisterBindingConfig {
  context: MachineRegisterBindingContext;
}

export interface MachineRegisterBindingContext {
  registers: {
    type: 'input' | 'output';
    dataType: 'bit' | 'int' | 'double';
    index: number;
    outputKey: string;
  }[];
}

export interface MachineRegisterBindingResult {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [outputKey: string]: any;
}

export type ResetLiveFlowExecutionLazyResult = (
  machineId: string
) => Promise<void>;

export const useMachineRegisterBinding = (
  machineId: string,
  config: RegisterBindingConfig
): MachineRegisterBindingResult | undefined => {
  const variables: RegisterAndSubscribeToMachineBindingSubscriptionVariables = {
    input: {
      machineId,
      binding: {
        namespace: 'machine',
        type: 'register',
        context: config.context,
      },
    },
  };

  const { data } =
    useApolloSharedSubscription<RegisterAndSubscribeToMachineBindingSubscriptionResult>(
      {
        query: RegisterAndSubscribeToMachineBindingDocument,
        variables,
        subscriptionName: `binding-machine-register-${machineId}`,
      }
    );

  return data?.registerAndSubscribeToMachineBindingResult?.data;
};
